export enum SIGN_IN_STEP {
  /* The user must select the preferred MFA method */
  SELECT_MFA_TYPE = 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
  /** The user must enter the code from an authenticator app (e.g., Google Authenticator) */
  SOFTWARE_TOKEN_MFA = 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
  /** The user must enter the code received by SMS */ // 'SOFTWARE_TOKEN_MFA',
  SMS_MFA = 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
  /** The user must enter the code received by Email */
  EMAIL_MFA = 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE',
  /** The user must change their password (common on first login) */
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',

  CONFIRM_RESET_PASSWORD_WITH_CODE = 'CONFIRM_RESET_PASSWORD_WITH_CODE',

  RESET_PASSWORD = 'RESET_PASSWORD',

  DONE = 'DONE',
}
